"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageAttemptFailingEvent = void 0;
class MessageAttemptFailingEvent {
    constructor() {
    }
    static getAttributeTypeMap() {
        return MessageAttemptFailingEvent.attributeTypeMap;
    }
}
exports.MessageAttemptFailingEvent = MessageAttemptFailingEvent;
MessageAttemptFailingEvent.discriminator = undefined;
MessageAttemptFailingEvent.attributeTypeMap = [
    {
        "name": "data",
        "baseName": "data",
        "type": "MessageAttemptFailingEventData",
        "format": ""
    },
    {
        "name": "type",
        "baseName": "type",
        "type": "MessageAttemptFailingEventTypeEnum",
        "format": ""
    }
];
//# sourceMappingURL=MessageAttemptFailingEvent.js.map